import { render, staticRenderFns } from "./PercentBarGroup.vue?vue&type=template&id=2b229ce6"
import script from "./PercentBarGroup.vue?vue&type=script&lang=js"
export * from "./PercentBarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports